module.exports = __webpack_public_path__ + "img/4.554768eb.png";